import { Link } from "react-router-dom";
import "./Header.css";

type HeaderPropsType = {
  headerText?: string;
};

const Header: React.FC<HeaderPropsType> = ({ headerText }) => {

  return (
    <div>
      <Link to={`/`} state={{ isCaptureModeForced: true, isUploadOnly: false, isStartEditMode: false }}><div className="btn btn-primary px-8 w-full md:w-fit">&#8249; 名刺のホーム画面に戻る</div></Link>
    </div>

  );
}

export default Header;
